import React, { Fragment, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import PerfilBasicoCliente from "./PerfilBasicoCliente";
import Intereses from "./Intereses";
import Comentarios from "./Comentarios";
import Alertas from "./Alertas";
import { useParams } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";

const Estudiante = (props) => {
    const [comments, setComments] = useState([]);
    const [intereses, setIntereses] = useState([]);
    const [idInteresado, setIdInteresado] = useState("");
    const history = useHistory();
    const methods = useForm();

    const onSubmit = (data) => {
       // document.getElementById("buttonSave").disabled = true;
        if (intereses.length < 1 )
            alert('Debe ingresar al menos un Interes');
        else if (comments.length < 1)
           alert('Debe ingresar al menos un Comentario');
        else if (idInteresado && idInteresado !== "")
        {
            data = { id: idInteresado, ...data };
            data = { ...data, comments: comments };
            data = { ...data, intereses: intereses };
          
            const requestOptions = {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            };

            fetch(`${process.env.REACT_APP_API_URL}/estudiante`, requestOptions)
                .then((response) => {
                    if (response.status === 200) {
                        response.json().then((data) => {
                            if (data.affectedRows === 1) {
                                alert("Se actualizo correctamente.");
                                history.push("/estudiante/" + idInteresado);
                            } else {
                                alert("No se pudo actualizar.");
                            }
                        });
                    } else {
                        if (response.status === 409) {
                            alert("Este telefono ya se encuentra registrado.");
                            document.getElementById("buttonSave").disabled = false;
                        }
                    }
                })
                .then((data) => { });
        } else {
            data = { ...data, comments: comments };
            data = { ...data, intereses: intereses };

            const requestOptions = {
                method: "PUT",
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            };
            
            fetch(`${process.env.REACT_APP_API_URL}/estudiante`, requestOptions)
                .then((response) => {
                    if (response.status === 200) {
                        response.json().then((data) => {
                            alert("Se guardo correctamente con el codigo: " + data.insertId);
                            history.push("/estudiantes");
                        });
                    } else {
                        if (response.status === 409) {
                            alert("Este telefono ya se encuentra registrado.");
                            document.getElementById("buttonSave").disabled = false;
                        }
                    }
                })
                .catch((err) => {
                    alert("Ocurrio un error al intentar guardar. \nCode: " + err);
                    document.getElementById("buttonSave").disabled = false;
                });
        }
    };

    let perfilBasicoCallback = (childData) => {
        //console.log("IdInteresado: " + childData);
        setIdInteresado(childData);
    };

    let interesesCallback = (childData) => {
        //  console.log(childData);
        setIntereses(childData);
    };

    let comentariosCallback = (childData) => {
        //console.log(childData);
        setComments(childData);
    };

    return (
        <div>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <PerfilBasicoCliente disabled={props.disabled} parentCallback={perfilBasicoCallback} />
                    <Intereses disabled={props.disabled} parentCallback={interesesCallback} />
                    <Comentarios disabled={props.disabled} parentCallback={comentariosCallback} />
                    {!props.disabled && (
                        <button id="buttonSave" type="submit" className="btn btn-primary my-1">
                            <i className="bi bi-save"></i> Guardar
                        </button>
                    )}
                </form>
            </FormProvider>
        </div>
    );
};

export default Estudiante;
